import convertDataURIToBinary from "../utils/convertDataURIToBinary.js";
import aesjs from "aes-js";

/**
 * getting new prop
 * @param {string} data - the data that needs manipulation
 * @returns new prop
 */
const getNewProp = (data, aesjsKey) => {
  //need to check if the response is the base64 text or error
  const key = aesjs.utils.utf8.toBytes(aesjsKey);

  // The initialization vector (must be 16 bytes)
  const iv = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  // Convert text to bytes (text must be a multiple of 16 bytes)
  const textBytes = convertDataURIToBinary(data);

  // The cipher-block chaining mode of operation maintains internal
  // state, so to decrypt a new instance must be instantiated.
  const aesCbc = new aesjs.ModeOfOperation.cbc(key, iv);
  const decryptedBytes = aesCbc.decrypt(textBytes);

  // Convert bytes back into text and return it
  const decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);
  const result = decodeURIComponent(escape(decryptedText));
  return result;
};

export default getNewProp;
